export default __webpack_public_path__ + "static/media/elektra.40b62532.png";